export const ShortcutsQuery = `
  "shortcuts": shortcuts[]{
    ...,
    "icon": icon->icon
  }
`;
